export const SET_LAWS_WAITING_FETCHING = 'SET_LAWS_WAITING_FETCHING';
export const SET_LAWS_WAITING = 'SET_LAWS_WAITING';
export const SET_LAWS_WAITING_ERROR = 'SET_LAWS_WAITING_ERROR';
export const CLEAN_LAWS_WAITING = 'CLEAN_LAWS_WAITING';
export const ABORT_LAWS_WAITING_REQUEST = 'ABORT_LAWS_WAITING_REQUEST';
export const RESET_LAWS_WAITING_FETCHING = 'RESET_LAWS_WAITING_FETCHING';



// WEBPACK FOOTER //
// ./src/redux_related/lawsWaiting/actions.js